import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConferenceRegistration } from 'app/models/conference-registration.model';
import { ConventionRegistration } from 'app/models/convention-registration.model';
import { QRCodeExtension } from 'app/models/extensions/q-r-code-extension.model';

export class QRCode extends QRCodeExtension {
  qrCodeDBID: number = 0;
  qrCodeImage: number[] = [];
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  conferenceRegistrations: ConferenceRegistration[] = [];
  conventionRegistrations: ConventionRegistration[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      qrCodeDBID: new FormControl({ value: 0, disabled: disableAll }),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      qrCodeImage: new FormArray([]),
      conferenceRegistrations: new FormArray([]),
      conventionRegistrations: new FormArray([])
    });


    return form;
  }
}